<template>
    <div class="message_center" v-loading="loading">
        <section class="msg-header">
            <el-tabs class="msg-tab-list" v-model="tabName" @tab-click="handleTabClick">
                <el-tab-pane
                    v-for="(tabItem, tebIndex) in msgTabList"
                    :key="tebIndex"
                    :name="tabItem.name">
                    <span slot="label">
                        <i class="new-msg" v-if="tabsReadObj[tabItem.name]"></i>
                        {{tabItem.label}}
                    </span>
                </el-tab-pane>
            </el-tabs>
            <span :class="['all-read', {'disabled': !haveUnRead}]" @click="onReadAll">全部标记为已读</span>
        </section>
        <section class="tab-content" v-loading="loading ? false : tabLoading" element-loading-text="拼命加载中">
            <template v-if="componentData.length">
                <dl v-for="(val, valIndex) in componentData" :key="valIndex">
                    <dt class="dt-title">{{ val.date }}</dt>
                    <dd class="dd-info" v-for="(item, index) in val.info" :key="index">
                        <span class="circle"></span>
                        <span class="time">{{ item.time }}</span>
                        <p class="content-info" v-html="filerXSS(item.message)"></p>
                    </dd>
                </dl>
            </template>
            <div v-else class="data-null">
                <img src="../../images/personal_center/data-null.png" alt="">
                <p>没有数据</p>
            </div>
            <!-- 滚动加载loading -->
            <div class="load-more" v-if="isMoreLoading || componentData.length > 10">
                <img v-if="isMoreLoading" alt="loadding" src="../../images/common/loading_2_24x24.gif">
                <span v-else>{{ totalPage === curPage ? '没有更多内容了' : '显示更多' }}</span>
            </div>
        </section>
    </div>
</template>

<script>
import personalCenter from '@/mixins/personalCenter.js'
export default {
    mixins: [ personalCenter ],
    data() {
        return {
            loading: true,
            followLoading: false,
            remindLoading: false,
            latterLoading: false,
            systemLoading: false,
            prevActive: '',
            msgTabList: [
                {
                    label: '回复与获赞',
                    name: 'follow'
                }, {
                    label: '关注更新',
                    name: 'remind'
                },
                // {
                //     label: '私信留言',
                //     name: 'latter'
                // },
                {
                    label: '系统消息',
                    name: 'system'
                }
            ],
            tabsReadObj: {
                follow: false,
                remind: false,
                latter: false,
                system: false
            },
            componentData: []
        }
    },
    watch: {
        '$route.query' (val) {
            const { tabName } = val
            if (tabName) {
                this.tabName = tabName
                this.getTabContent()
            }
        }
    },
    computed: {
        tabLoading () {
            return this[`${this.tabName}Loading`]
        },
        haveUnRead () {
            let result = false
            result = Object.values(this.tabsReadObj).some(item => item)
            return result
        }
    },
    created () {
        const { tabName } = this.$route.query
        this.tabName = tabName || 'follow'
        // 获取所有tab的消息列表
        this.getAllTabMsgList()
    },
    methods: {
        // 获取所有tab的消息列表
        getAllTabMsgList () {
            this.loading = true
            const promiseArray = this.msgTabList.map(item=> this.getTabContent(item.name))
            Promise.all(promiseArray).then(res=> {
                this.loading = false
            })
        },
        // 获取tab栏内容数据
        async getTabContent (type = this.tabName, isMore) {
            try {
                if (isMore) {
                    this.isMoreLoading = true
                } else {
                    this[`${type}Loading`] = true // 获取所有tab数据的时候不需要单独加载loading
                }
                await axios.get(myUrl + `api/notify/record/?type=${type}`, {
                    params: {
                        page: this.curPage,
                        page_size: 20
                    }
                }).then(res => {
                    if (!res.data.result) return
                    this.tabsReadObj[type] = res.data.data.have_unread
                    if (type !== this.tabName) return

                    // 添加用户列表
                    this.totalPage = Math.ceil(res.data.data.count / 20)
                    this.isPageOver = this.curPage >= this.totalPage

                    if (isMore) {
                        this.componentData.push(...res.data.data.notify)
                    } else {
                        this.componentData = res.data.data.notify
                    }
                    this.onReadNotify(type)
                })
            } catch (error) {
                console.warn(error)
            } finally {
                this[`${type}Loading`] = false
                this.isMoreLoading = false
            }
        },
        // tab切换
        handleTabClick (data) {
            this.curPage = 1
            this.$router.push({
                query: {
                    tabName: data.name
                }
            })
        },
        // 单个tab已读
        onReadNotify (type) {
            if (!this.prevActive) {
                this.prevActive = type
                return
            }
            try {
                axios.put(myUrl + `api/notify/record/read/?type=${this.prevActive}`).then(res => {
                    if (!res.data.result) return
                    this.tabsReadObj[this.prevActive] = false
                    this.prevActive = type
                })
            } catch (error) {
                console.warn(error)
            }
        },
        // 所有已读
        onReadAll () {
            try {
                axios.put(myUrl + `api/notify/record/read/?type=all`).then(res => {
                    if (!res.data.result) return
                    Object.keys(this.tabsReadObj).forEach(item => {
                        this.tabsReadObj[item] = false
                    })
                })
            } catch (error) {
                console.warn(error)
            }
        },
        // 监听滚动
        handleScroll () {
            // 滚动加载
            this.scrollLoading(this.getTabContent)
        }
    }
}
</script>
<style lang="scss">
    .msg-tab-list {
        height: 52px;
        line-height: 52px;
        .el-tabs__active-bar {
            width: 70px !important;
        }
        .el-tabs__item {
            position: relative;
            width: 70px;
            text-align: center;
            box-sizing: content-box;
            .new-msg {
                position: absolute;
                width: 12px;
                height: 12px;
                transform: scale(.5);
                top: 5px;
                right: 10px;
                border-radius: 50%;
                background: #ea3636;
            }
            &:last-child {
                padding-right: 20px !important;
                .new-msg {
                    right: 10px;
                }
            }
        }
    }
    .tab-content {
        min-height: 200px;
        padding: 20px;
        margin-bottom: 38px;
        background: #fff;
        dl {
            margin-bottom: 6px;
            &:last-child {
                margin-bottom: 0;
            }
        }
        .dt-title {
            color: #313238;
            font-size: 14px;
            line-height: 19px;
            margin-bottom: 12px;
        }
        .dd-info {
            display: flex;
            word-wrap: break-word;
            line-height: 26px;
            margin: 12px 0;
            color: #63656e;
            .circle {
                width: 4px;
                height: 4px;
                background: #979ba5;
                border-radius: 50%;
                margin: 12px 8px 0 0;
            }
            .time {
                margin-right: 16px;
            }
            .content-info {
                flex: 1;
                color: #979ba5;
                em {
                    font-style: normal;
                }
                a:hover {
                    text-decoration: underline;
                }
            }
        }
        .data-null {
            padding: 50px 0 20px;
            width: 100%;
            text-align: center;
            color: #63656e;
            img {
                width: 120px;
                height: 100px;
                margin-bottom: 10px;
            }
        }
    }
    .el-loading-mask {
        z-index: 20;
        background-color: rgba(255, 255, 255, 0.9);
        .el-loading-text {
            color: #63656e;
        }
    }
</style>
<style lang="scss" scoped>
    .message_center {
        width: 100%;
        background: #fff;
        .msg-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 25px 0 20px;
            height: 52px;
            border-bottom: 1px solid #dcdee5;
            .all-read {
                cursor: pointer;
                color: #3a84ff;
                &.disabled {
                    cursor: not-allowed;
                    color: #c4c6cc;
                }
            }
        }
      
    }
</style>


// WEBPACK FOOTER //
// message_center.vue?0e7c6d33